export const environment =
{
  production: false,
  defaultauth: 'fackbackend',

  //*******************Desarrollo************************
  //apiUrl: 'https://circular-back-test.smallshi.com/api',
  //keyPusher:'20178bd828918e8aee99',

  //*******************Produccion************************
  apiUrl: 'https://back.circulartrans.com/api',
  keyPusher:'822e54a0b90c5ec053b4',

  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  }
};
